import React from "react";

export default function AVCInformationText({
  issuerId,
  issuerBankName,
  vehicleclass,
  differentialAmount,
  readerReadTime,
  seatingCapacityEnabled,
  seatingCaseDifferentialAmount,
  gvwCaseDifferentialAmount,
  avcAmount,
  violationBasedOn,
}) {
  const highestDifferentialAmount = Math.max(
    avcAmount ?? -Infinity,
    gvwCaseDifferentialAmount ?? -Infinity,
    seatingCapacityEnabled
      ? seatingCaseDifferentialAmount ?? -Infinity
      : -Infinity
  );

  const approvalBasedOn =
    violationBasedOn === "avc"
      ? "AVC"
      : violationBasedOn === "gvw"
      ? "GVW"
      : violationBasedOn === "seating"
      ? "Seating"
      : "";

  const isHighlighted = (type) => violationBasedOn === type;

  return (
    <div id="imgzoom">
      <div className="img-information">
        <div>
          <div className="info-label">Vehicle Class</div>
          <div className="info-value">{vehicleclass}</div>
        </div>

        <div>
          <div className="info-label">Reader Read Time</div>
          <div className="info-value">{readerReadTime}</div>
        </div>

        <div>
          <div className="info-label">Issuer ID</div>
          <div className="info-value">{issuerId}</div>
        </div>

        <div>
          <div className="info-label">Issuer Bank Name</div>
          <div className="info-value">{issuerBankName}</div>
        </div>

        <div>
          <div className="info-label">Differential Amount</div>
          <div className="info-value">{differentialAmount}</div>
        </div>

        <div>
          <div className="info-label">AVC</div>
          <div
            className={`info-value ${isHighlighted("case") ? "highlight" : ""}`}
          >
            {avcAmount ?? 0}
          </div>
        </div>

        <div>
          <div className="info-label">GVW</div>
          <div
            className={`info-value ${isHighlighted("gvw") ? "highlight" : ""}`}
          >
            {gvwCaseDifferentialAmount ?? 0}
          </div>
        </div>

        {seatingCapacityEnabled && (
          <div>
            <div className="info-label">Seating</div>
            <div
              className={`info-value ${
                isHighlighted("seating") ? "highlight" : ""
              }`}
            >
              {seatingCaseDifferentialAmount ?? 0}
            </div>
          </div>
        )}

        <div>
          <div className="info-label">Approval Details</div>
          <div className="info-value">{approvalBasedOn}</div>
        </div>
      </div>
    </div>
  );
}
